<script setup lang="ts">
import { type PortableTextBlock } from 'sanity';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    text: PortableTextBlock | string;
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  content: props.block?.text,
}))

</script>

<template>
  <div class="wrapper wrapper--content">
    <component :is="props.config?.innerComponent" v-bind="data" />
  </div>
</template>
